import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Toolbar, Box, Button } from '@mui/material';
import logo from '../assets/logo.png';

const navItems = [
  { title: 'Home', path: '/' },
  { title: 'Login', path: '/login' },
];

const Navbar = ({ isLoggedIn }) => {
  return (
    <AppBar position="static" sx={{ backgroundColor: '#fff', boxShadow: 'none', borderBottom: '5px solid #f8b500' }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          <img src={logo} height='130px' alt="logo" />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {!isLoggedIn &&
            navItems.map((item) => (
              <Button
                key={item.title}
                component={RouterLink}
                to={item.path}
                sx={{ color: '#000', ml: 3, fontWeight: 600 }}
              >
                {item.title}
              </Button>
            ))}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
